import Router from 'next/router';
import { LOGIN_ACTION, PAYMENT_CONFIRMATION_ACTION } from './constants';
import {
  CurrentUser,
  Price,
  PriceTypeKind,
  ProgramAccessStatus,
  ProgramCategory,
} from '@gql/generated';

export function borders(type) {
  return `
    border-top: 1px solid #dddddd;
    border-bottom: 1px solid #dddddd;
    ${type === 'both' &&
      `
        border-left: 1px solid #dddddd;
        border-right: 1px solid #dddddd;
        border-radius: 3px;
      `};

    ${type === 'left' &&
      `
        border-right: 0;
        border-left: 1px solid #dddddd;
        border-top-left-radius: 3px;
        border-bottom-left-radius: 3px;
      `};

    ${type === 'right' &&
      `
        border-left: 0;
        border-right: 1px solid #dddddd;
        border-top-right-radius: 3px;
        border-bottom-right-radius: 3px;
      `};
    `;
}

export const getMargins = (index, length, nextline = 0) => {
  const margins = {
    mb: [20, 20],
  };

  if (index === 0 || index === nextline)
    return {
      ...margins,
      pl: 0,
      pr: [0, 20],
    };

  if (index === length - 1 || index === length + nextline - 1)
    return {
      ...margins,
      pl: [0, 20],
      pr: 0,
    };

  return {
    ...margins,
    px: [0, 10],
  };
};

export const getUserProgramAccess = ({
  user,
  programSlug,
  programCategory,
}: {
  programSlug: string;
  user: CurrentUser;
  programCategory: ProgramCategory;
}) => {
  if (programSlug) {
    if (
      user?.courseAccesses &&
      programCategory === ProgramCategory['Courses']
    ) {
      return user.courseAccesses?.find(p => {
        if (p.course.slug === programSlug) {
          return true;
        }
      });
    } else if (
      user?.programAccess &&
      programCategory === ProgramCategory['Programs']
    ) {
      return user.programAccess?.find(p => {
        if (p.program.slug === programSlug) {
          return true;
        }
      });
    }
  }
  return null;
};

export const hideURLParams = action_type => {
  const { pathname, query } = Router;
  if (action_type === PAYMENT_CONFIRMATION_ACTION) {
    const expectedParams = [
      'action',
      'amount',
      'amount_cents',
      'subscription_type',
      'recurring_date',
      'recurring_amount',
      'months',
      'recurring_currency',
      'currency',
      'amount_currency',
      'email',

      // these are probably sent by adyen
      'payload',
      'type',
      'resultCode',
      'order_id',
      'transact',
      'transaction',
    ];

    const params = Object.fromEntries(
      Object.entries(query).filter(([key]) => {
        if (expectedParams.includes(key)) {
          return false;
        }
        return true;
      })
    );

    Router.replace({ pathname, query: params });
  } else if (action_type === LOGIN_ACTION) {
    // TODO: handle login clean up here
  }
};

export const getVideoDescription = video => {
  if (video?.content) {
    const { longDescription, shortDescription } = video.content;
    return shortDescription || longDescription;
  }
  return '';
};

export function normalizeImagePath(value) {
  if (String(value).startsWith('//')) {
    return 'https:' + value;
  }
  return value;
}

export const canBuyProgramGift = (price: Price, priceType: PriceTypeKind) => {
  if (
    [
      PriceTypeKind['AccessCodesOnly'],
      PriceTypeKind['BySubscription'],
      PriceTypeKind['FreeForAll'],
    ].includes(priceType) ||
    price === null
  ) {
    return false;
  }

  return true;
};

export const canExtendProgramAccess = (
  price: Price,
  priceType: PriceTypeKind,
  accessStatus: ProgramAccessStatus
) => {
  if (
    ([PriceTypeKind['BySubscription'], PriceTypeKind['FreeForAll']].includes(
      priceType
    ) ||
      price === null) &&
    ![
      ProgramAccessStatus['Expired'],
      ProgramAccessStatus['ExpiringSoon'],
    ].includes(accessStatus)
  ) {
    return false;
  }

  return true;
};
